import { useEffect, useRef, useState } from 'react';
import { erApiFeil } from '../api/feil.ts';
import { useSettVisningsnavn } from '../api/useMe.ts';
import { Flate, Fot, Tekstknapp, Varsel } from './deler.tsx';

/**
 * W1 — navnet (`hypotese-innsending.jsx`, SideNavn). Ett felt, én knapp, én setning. Feltet
 * viser navnet personen har (`forrige`, fra «meg» — API-et satte det fra innloggingstjenesten
 * ved første innlogging, H2.9 og DD-81), og er tomt bare når det ikke finnes. Panelet leser
 * aldri innloggingens profil selv. 2–60 tegn (`AdminMe.displayName`); for kort gir låsen i
 * foten, ikke en etikett (DD-44). ↵ lagrer (`PATCH /v1/admin/me`), og skjemaet åpnes på samme
 * adresse.
 */
export function NavnSide({ tittel, forrige, onLagret, onLukk }: { tittel: string; forrige?: string; onLagret: () => void; onLukk: () => void }) {
  const [navn, setNavn] = useState(forrige ?? '');
  const sett = useSettVisningsnavn();
  const felt = useRef<HTMLInputElement>(null);
  const trimmet = navn.trim();
  const grunn = trimmet.length < 2 ? 'Navnet må ha minst 2 tegn.' : trimmet.length > 60 ? 'Navnet kan ha høyst 60 tegn.' : null;

  useEffect(() => felt.current?.focus(), []);

  const lagre = () => {
    if (grunn || sett.isPending) return;
    sett.mutate(trimmet, { onSuccess: onLagret });
  };

  return (
    <Flate
      tittel={tittel}
      tilbake={{ navn: 'Mine hypoteser', til: '/h/mine' }}
      bredde="smal"
      midt
      fot={<Fot venstre={<Tekstknapp onClick={onLukk}>Lukk</Tekstknapp>} grunn={grunn} primar={{ label: 'Lagre navnet', onClick: lagre, tast: 'enter', opptatt: sett.isPending, testid: 'h-lagre-navn' }} />}
    >
      <h2 className="h-sporsmal">Slik ser kollegene navnet ditt</h2>
      <div className="h-felt">
        <label htmlFor="h-navn" className="h-etikett">
          Visningsnavn
        </label>
        <input
          ref={felt}
          id="h-navn"
          className="h-stort"
          value={navn}
          maxLength={60}
          aria-describedby="h-navn-hjelp"
          onChange={(e) => setNavn(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.ctrlKey && !e.metaKey) {
              e.preventDefault();
              lagre();
            }
          }}
          data-testid="h-navn"
        />
      </div>
      <p id="h-navn-hjelp" className="h-tekst-dempet">
        Det står på det du sender inn, og du kan endre det senere under «⋯».
      </p>
      {sett.isError ? <Varsel>{erApiFeil(sett.error) ? sett.error.brukertekst : 'Navnet ble ikke lagret. Prøv igjen.'}</Varsel> : null}
    </Flate>
  );
}
